import { render, staticRenderFns } from "./TouchpointOverviewPopup.vue?vue&type=template&id=19a32c5b&"
import script from "./TouchpointOverviewPopup.vue?vue&type=script&lang=js&"
export * from "./TouchpointOverviewPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Data\\TeamCity\\buildAgent\\work\\6dffdb6616650f37\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19a32c5b')) {
      api.createRecord('19a32c5b', component.options)
    } else {
      api.reload('19a32c5b', component.options)
    }
    module.hot.accept("./TouchpointOverviewPopup.vue?vue&type=template&id=19a32c5b&", function () {
      api.rerender('19a32c5b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/CanvasArea/Bricks/TouchpointOverview/TouchpointOverviewPopup.vue"
export default component.exports